import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { NAVIGATE_PATH as PATH } from '../../../helpers/constants';
import { useAppDispatch } from '../../../hooks/hooks';
import { IUser } from '../../../models/IUser';
import { logout } from '../../../requests';
import { clearCart } from '../../../store/reducers/userSlice';

/**
 * The account block at the foot of the ops and customer-admin sidebars:
 * the signed-in person, a link to their settings, and sign out. Same
 * sign-out sequence as the learner header's user dropdown.
 */
const SidebarAccount: React.FC<{ user: IUser; subtitle: string }> = ({
  user,
  subtitle,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const signOut = () => {
    localStorage.clear();
    dispatch(clearCart());
    logout().then(() => navigate(PATH.login, { replace: true }));
  };

  return (
    <div className="border-t border-white-regular px-3 py-3">
      <Link
        to={PATH.profileSettings}
        title="Account settings"
        className="block rounded-lg px-3 py-2 transition-colors hover:bg-grey-50"
      >
        <div className="truncate text-xs font-medium text-gray-five">
          {user.email}
        </div>
        <div className="truncate text-[11px] text-gray-bold">{subtitle}</div>
        <div className="mt-1 text-[11px] font-medium text-blue-primary">
          Account settings →
        </div>
      </Link>
      <button
        type="button"
        onClick={signOut}
        className="mt-1 block w-full rounded-lg px-3 py-1.5 text-left text-[11px] text-gray-three transition-colors hover:bg-grey-50 hover:text-gray-four"
      >
        Sign out
      </button>
    </div>
  );
};

export default SidebarAccount;
